import { render, staticRenderFns } from "./tpl-pages-private.vue?vue&type=template&id=a88e3bd2&scoped=true&"
import script from "./tpl-pages-private.vue?vue&type=script&lang=js&"
export * from "./tpl-pages-private.vue?vue&type=script&lang=js&"
import style0 from "./tpl-pages-private.vue?vue&type=style&index=0&id=a88e3bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88e3bd2",
  null
  
)

export default component.exports